import styled from 'styled-components';

export const GridWrapper = styled.div`
  position: relative;
  margin: 0 auto;
`;
